var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    fillRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4836 5.93636C16.7944 5.21927 13.679 2.12262 11.6509 0.405432C10.9653 -0.175113 10.3902 -0.171701 10.3902 0.674185C10.3902 1.52007 10.3902 3.31384 10.3902 3.31384H8.87364C4.17106 3.31384 0.747059 6.96409 0.0878897 11.7295C-0.290742 13.7748 0.641287 13.728 1.22305 12.7379C2.81632 10.4722 6.56347 10.6757 9.96095 10.6757H10.3902C10.3902 10.6757 10.3902 12.1716 10.3902 13.0175C10.3902 13.8634 10.7677 14.3338 11.4942 13.7216C13.1851 12.2968 17.0048 8.53369 17.5729 7.97759C18.141 7.42151 18.1728 6.65343 17.4836 5.93635V5.93636Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.50051904f8905c885bf013e44db300cf.svg";
export { ForwardRef as ReactComponent };